module.exports = __webpack_public_path__ + "img/wechat.27b9f47f.png";